<app-header></app-header>
<section class="middle-section salary-revise">
  <div class="container-fluid">
    <div class="initiale_sestion">
      <div class="head">
        <div class="title-container">
          <i (click)="goback()" class="fa-solid fa-angle-left"></i>
          <h4 class="form-title-sm">{{'Employee History' | translate}}</h4>
        </div>
      </div>
    </div>
    <div *ngIf="employeeDetails" class="user-data-container">
      <div class="user-data">
        <div class="child-container">
          <label class="labeltxt-sm">{{'Employee CCPS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.ccps_code">{{employeeDetails.ccps_code}}</h6>
          <h6 *ngIf="!employeeDetails.ccps_code">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Name' | translate}}</label>
          <h6>{{employeeDetails.name}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'position' | translate}}</label>
          <h6>{{employeeDetails.designation}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNAMGS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnamgs">{{employeeDetails.cnamgs}}</h6>
          <h6 *ngIf="!employeeDetails.cnamgs">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'CNSS ID' | translate}}</label>
          <h6 *ngIf="employeeDetails.cnss">{{employeeDetails.cnss}}</h6>
          <h6 *ngIf="!employeeDetails.cnss">--</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Mobile' | translate}}</label>
          <h6>{{employeeDetails.mobile}}</h6>
        </div>
        <h4>{{'Resignation Details' | translate}}</h4>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Reason For Resignation' | translate}}</label>
          <h6>{{employeeDetails.reason}}</h6>
        </div>
        <div class="child-container">
          <label class="labeltxt-sm">{{'Date of Resignation' | translate}}</label>
          <h6>{{employeeDetails.resigned_date}}</h6>
        </div>
         <div class="child-container full-width">
          <label class="labeltxt-sm">{{'Reason' | translate}}</label>
          <h6>{{employeeDetails.reason}}</h6>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
